<div class="row col-12 p-0 m-0 main-page-section ">
  <!-- <div class="p-0">
        <app-side-nav [item]="meetingNav"></app-side-nav>
    </div> -->
  <div class="col-12 p-0 book-meeting-section">
    <!-- <app-header></app-header> -->
    <div class="row col-12 p-0 m-0">

      <div class="col-12 p-0 col-height c2">

        <div>
          <div class="">
            <div class="breadcrumbs-section ">
              <span class="prev-page pr-1 prev" routerLink="/overview">Home</span>
              <span class="separator">&nbsp; > &nbsp;</span>
              <span class="prev-page pr-1 prev" routerLink="/meeting/meetingroom-list">Meetings</span>
              <span class="separator">&nbsp; > &nbsp;</span>
              <span class="curr-page pl-1">Book a Meeting Room</span>
            </div>
            <div class="d-flex justify-content-between meetings-layout booking-heading">
              <p>Book a Meeting Room</p>
              <div class="justify-content-end booking-history pt-3 pointer-link" routerLink="/reports">
                Booking History
              </div>
            </div>
            <div class="d-flex meetings-layout pb-3">
              <img src="/assets/images/Credit-group.png" class="pr-2 available-credit" loading="lazy" />Available credit
              Points <span class="booking-history pl-2 pt-1">{{availableCredits}}</span>
            </div>
          </div>


          <div class="col-12 row borders m-0 p-0 ">
            <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent"
              triggers="manual" #p="ngbPopover" (click)="openPopover(p)" placement="bottom"
              popoverClass='dash-popover dashboard-popover'
              class="col-2 host-email-id1 pointer-link relative-content borders-right">
              <div class="center-align box-size">
                <span>Host Email ID</span>
                <img src="/assets/images/Path.png" class="padding-left-image pr-1 pointer-link" loading="lazy" />
                <div class="all-hosts-email pointer-link"
                  [innerHTML]="selectedEmail === null ? 'All Hosts' : selectedEmail.emailId">
                </div>
              </div>

              <div>
                <ng-template #popContent>
                  <div class="dashboard-popover ">
                    <div class="search-wrapper">
                      <label for="search">
                        <img class="image-pos pl-3" src="/assets/images/search.png" alt="search" loading="lazy">
                        <input class="search-box pl-5 search-text" type="text" name="search" id="menu-search"
                          [(ngModel)]="searchText" placeholder="Search">
                      </label>
                    </div>
                    <div class="d-flex justify-content-between scrolltoModal">
                      <div class="pl-3 pr-3 pb-3 ">
                        <div class="row pb-2 pointer-link" *ngFor="let emailId of emailList |filterHost:searchText">
                          <div class="popover-content pl-3 email-width" (click)="selectEmailid(emailId);openPopover(p)"
                            [class]="selectedIndex == emailId.id?'bold-font':'normal-font'">{{emailId.user.emailId}}
                          </div>
                          <div>
                            <img src="/assets/images/tick.png" *ngIf="selectedIndex == emailId.id"
                              class="pl-2 pr-1 mr-0 " loading="lazy" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>

            <div class="col-3 pt-3 pb-3 borders-right">
              <div class="pl-3 ">
                <span class="host-email-id pt-3 pointer-link" style="
                    position: absolute;
                    padding-left: 31px;margin-top: -14px;">Date</span>
                <input class="cal-icon all-hosts pt-3 pointer-link displayNone" autocomplete="off" [startDate]="model"
                  [(ngModel)]="model" [readonly]="true" (dateSelect)="updateSelectedDate($event)"
                  placeholder="Today,{{valuedate | date: ' d MMM'}}" (click)="d1.toggle()"
                  (keypress)="$event.preventDefault()" id="meetingdate" type="text" name="dp1" ngbDatepicker
                  #d1="ngbDatepicker">
                <div class="displayDate">{{formatDate}}</div>
              </div>
              <!-- <input class="pl-5 cal-icon cal-border" autocomplete="off" [readonly]="true"   placeholder="Today,{{valuedate | date: ' d MMM'}}"  (click)="d1.toggle()" (keypress)="$event.preventDefault()"  id="owner-dob" type="text" name="dp1"
                ngbDatepicker #d1="ngbDatepicker"> -->
            </div>
            <div (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'" [ngbPopover]="popContent1"
              triggers="manual" #p1="ngbPopover" (click)="openPopover(p1)" placement="bottom"
              popoverClass='starttime-popover'
              class="col-sm-3 borders-right  padding-left-start-time host-email-id1 relative-content ">
              <!-- <div class="col-3 pt-3 pb-3 borders-right ">                  -->
              <div class="center-align box-size">
                <span class="host-email-id pt-3 start-time-pos pointer-link">Start time</span>
                <img src="/assets/images/clock-circular-outline.png" class="pl-2 pointer-link" loading="lazy" />
                <div class="all-hosts pointer-link" style="padding-left: 2.5rem">{{display}}</div>
              </div>

              <ng-template #popContent1>
                <div class="rectangle-copy-5">
                  <label class="start-time pl-4 pt-3">Start time</label>
                  <div class="pl-3 pr-4 pt-1 ">
                    <ngb-timepicker [(ngModel)]="normalizeTime" [meridian]="meridian"
                      (ngModelChange)="onTimeChange($event)" [minuteStep]="15"></ngb-timepicker>
                    <div>
                      <span class="hh-margin">hh</span>
                      <span class="mm-margin">mm</span>
                    </div>
                    <div class="toggle-position">
                      <label class="switch">
                        <input #saveamorpmCheckBox type="checkbox" id="saveamorpmCheckBox" [checked]="amorpm"
                          (change)="toggleAmPmSelection(saveamorpmCheckBox.checked)">
                        <span class="bookslider"></span>
                      </label>
                    </div>

                    <!-- <button class="btn btn-sm btn-outline-{{meridian ? 'success' : 'danger'}}" (click)="toggleMeridian()">
                                    Meridian - {{meridian ? "ON" : "OFF"}}
                                </button>
                                <hr>
                                <pre>Selected time: {{time | json}}</pre> -->
                  </div>
                </div>
              </ng-template>
            </div>
            <div class="col-3 pt-3 pb-3 borders-right " (clickOutside)="onClickedOutside($event)"
              [autoClose]="'outside'" [ngbPopover]="popContent2" triggers="manual" #p2="ngbPopover"
              (click)="openPopover(p2)" placement="bottom" popoverClass='duration-popover '
              class="col-3  pt-4  pr-0 padding-left-start-time host-email-id relative-content">
              <div class="center-align box-size">
                <span class="host-email-id pt-3 start-time-pos">Duration</span>
                <img src="/assets/images/stopwatch.png" class="pl-2 " loading="lazy" />
                <div class="all-hosts pointer-link" *ngIf="duration==1" style="padding-left: 2.5rem">{{duration}} hour
                </div>
                <div class="all-hosts pointer-link" *ngIf="duration!=1"
                  style="padding-left: 2.25rem;white-space: nowrap;">{{displayDuration}}</div>
              </div>
            </div>
            <ng-template #popContent2>
              <div class=" rectangle">
                <label class="start-time pl-4 pt-3">Duration</label>
                <div class="pl-4 pr-4 pt-1 ">
                  <ngb-timepicker #dt [(ngModel)]="duration" [meridian]="meridian"
                    (ngModelChange)="onDurationChange($event)" [hourStep]="0" [minuteStep]="30" [meridian]="false">
                  </ngb-timepicker>
                  <div>
                    <span class="hh-margin">hh</span>
                    <span class="mm-margin">mm</span>
                  </div>
                </div>
                <div class="pt-4 pl-2 pr-3 duration-text">
                  From {{display}} to {{displayTotalTime}}
                  <!-- From {{date | date: 'hh:mm a'}} to {{timer| date: 'hh:mm a'}} -->
                </div>
              </div>
            </ng-template>
          </div>
        </div>
        <div style="min-height: 356px;" *ngIf="availableData.length>0">
          <div class="available-rroms padding-left-meeting pt-3 pb-3" *ngIf="availableData.length>0">Available Meeting
            Rooms</div>
          <div class="row pointer-link meeting-cards" *ngIf="availableData.length>0">
            <div class="mask col-6 p-0" *ngFor="let meetingroom of availableData; let i = index"
              (click)="openMeetingRoomDetails(meetingroom)">
              <div class="p-0 ">
                <img class="image-size" *ngIf="meetingroom?.meetingRoom.m0300MeetingRoomImages.length>0"
                  [src]="meetingroom?.meetingRoom.m0300MeetingRoomImages[0].imagePath" loading="lazy">
              </div>
              <div class="position-details">
                <div class="d-flex justify-content-between">
                  <span class="adventurer pt-3 pl-3">
                    {{meetingroom?.meetingRoom.name}}({{meetingroom?.meetingRoom.noOfPax}} pax)
                  </span>
                  <div class="credit pt-3 pr-3">
                    {{meetingroom?.meetingRoom.ratePerHour}} Credit/hr
                  </div>
                </div>

                <div class="pt-3">
                  <img src="/assets/images/monitor.png" class="pl-3" loading="lazy" />
                  <img src="/assets/images/wifi.png" class="pl-2 " loading="lazy" />
                  <img src="/assets/images/cup.png" class="pl-2 " loading="lazy" />
                </div>
                <div class="container pl-0 pr-0">
                  <div class="d-flex-slot">
                    <div *ngFor="let slot of timeStamps;">
                      <app-slot [data]="prepare(slot, meetingroom?.meetingRoom)" type='available'></app-slot>
                      <!-- <div  data="prepare(slot)" ></div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div style="padding-right:25px">
            </div>
            <div style="padding-right:25px">
            </div>
          </div>
        </div>
        <div style="min-height: 356px;" *ngIf="flexibleData.length>0">
          <div class="available-rroms padding-left-meeting pt-3 pb-3" *ngIf="flexibleData.length>0">Flexible with your
            time? Explore Other Rooms</div>
          <div class="row meeting-cards pointer-link" *ngIf="flexibleData.length>0">
            <div class="mask col-6 p-0" *ngFor="let meetingroom of flexibleData; let i = index"
              (click)="openMeetingRoomDetails(meetingroom)">
              <div class="p-0 ">
                <img class="image-size" *ngIf="meetingroom?.meetingRoom.m0300MeetingRoomImages.length>0"
                  [src]="meetingroom?.meetingRoom.m0300MeetingRoomImages[0].imagePath" loading="lazy">
              </div>
              <div class="position-details">
                <div class="d-flex justify-content-between">
                  <span class="adventurer pt-3 pl-3">
                    {{meetingroom?.meetingRoom.name}}({{meetingroom?.meetingRoom.noOfPax}} pax)
                  </span>
                  <div class="credit pt-3 pr-3">
                    {{meetingroom?.meetingRoom.ratePerHour}} Credit/hr
                  </div>
                </div>

                <div class="pt-3">
                  <img src="/assets/images/monitor.png" class="pl-3" loading="lazy" />
                  <img src="/assets/images/wifi.png" class="pl-2 " loading="lazy" />
                  <img src="/assets/images/cup.png" class="pl-2 " loading="lazy" />
                </div>
                <div class="container pl-0 pr-0">
                  <div class="d-flex-slot">
                    <div *ngFor="let slot of timeStamps;">
                      <app-slot [data]="prepare(slot, meetingroom?.meetingRoom)" type='flexible'></app-slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
</div>